import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type UserRole = 'admin' | 'viewer'

export interface AuthUser {
  username: string
  role: UserRole
  deployment_id?: string
  brand_ids?: string[]
}

export interface AuthState {
  token: string | null
  user: AuthUser | null
  setAuth: (token: string, user: AuthUser) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setAuth: (token, user) => set({ token, user }),
      clearAuth: () => set({ token: null, user: null }),
    }),
    { name: 'attribution-auth' },
  ),
)

export function getAuthToken(): string | null {
  return useAuthStore.getState().token
}
